import axios from 'axios';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { Phase } from '@/models/phase';
import type { Trade } from '@/models/trade';
import type { ProjectUser } from '@/models/projectUser';
import type { Project } from '@/models/project';
import type { Lesson } from '@/models/lesson';

class AppliedLessonWebservice {
    // noinspection JSUnusedGlobalSymbols
    public getByWorksheetId(worksheetId: number) {
        return axios.get('/appliedlessons/getByWorksheetId', {
            params: {
                worksheetId,
            },
        });
    }

    public update(appliedLesson: AppliedLesson) {
        return axios.post('/appliedlessons/update', {
            ...appliedLesson,
        });
    }

    public store(worksheetId: number, appliedLessons: AppliedLesson[], newAppliedLessons: AppliedLesson[]) {
        return axios.post('/appliedlessons/store', {
            worksheetId,
            appliedLessons,
            newAppliedLessons,
        });
    }

    public updateAppliedLessonAndLesson(appliedLesson: AppliedLesson, lesson: Partial<Lesson>) {
        return axios.post('/appliedlessons/updateAppliedLessonAndLesson', {
            id: appliedLesson.id,
            dynamic_field: appliedLesson.dynamic_field,
            contacttill: appliedLesson.contacttill,
            external_responsible_user: appliedLesson.external_responsible_user,
            internal_responsible_user: appliedLesson.internal_responsible_user,
            responsible_user: appliedLesson.responsible_user,
            todo: appliedLesson.todo,
            solution: appliedLesson.solution,
            lesson: {
                insight: lesson.insight,
                project_only: lesson.project_only,
                topic: lesson.topics,
            },
        });
    }

    public getToDos() {
        return axios.get('/appliedlessons/getToDos');
    }

    public getProjectOpenTasks(
        selectedTrades: Trade[],
        selectedPhase: Phase,
        selectedResponsibleUsers: ProjectUser[],
        selectedProject: Project
    ) {
        return axios.post('/appliedlessons/getProjectOpenTasks', {
            trades_ids: selectedTrades.map((el) => el.id),
            phase_id: selectedPhase.id,
            responsible_users: selectedResponsibleUsers,
            project_id: selectedProject.id,
        });
    }

    public emailTheOpenTasks(
        selectedTrades: Trade[],
        selectedPhase: Phase,
        selectedResponsibleUsers: ProjectUser[],
        selectedProject: Project
    ) {
        return axios.post('/appliedlessons/emailTheOpenTasks', {
            trades_ids: selectedTrades.map((el) => el.id),
            phase_id: selectedPhase.id,
            responsible_users: selectedResponsibleUsers,
            project_id: selectedProject.id,
        });
    }

    public remove(id: number) {
        return axios.delete('/appliedlessons/remove', {
            params: { id },
        });
    }
}

export const appliedLessonWebservice = new AppliedLessonWebservice();
